import { GenochUIPlugin } from '@genoch/genoch-ui-web';
import '@genoch/genoch-ui-web/style.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(GenochUIPlugin);
});
